import { render, staticRenderFns } from "./DentistTypes.vue?vue&type=template&id=66635005&scoped=true&"
import script from "./DentistTypes.vue?vue&type=script&lang=js&"
export * from "./DentistTypes.vue?vue&type=script&lang=js&"
import style0 from "./DentistTypes.vue?vue&type=style&index=0&id=66635005&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66635005",
  null
  
)

export default component.exports